import React from 'react';
import { Slide } from 'react-reveal'

function Reviews() {

  const tests = [
    {
      id: 1,
      name: "Sam Hopper",
      text: "Exploring Kenya with Explore Era was a dream come true! Witnessing the Great Migration was a wildlife spectacle I'll cherish forever. Thanks to Explore Era for an unforgettable adventure."
    },
    {
      id: 2,
      name: "Sara Malfoy",
      text: "My journey to Egypt with Explore Era was like stepping back in time. The Pyramids of Giza and sailing along the Nile were incredible experiences. Explore Era made sure every moment was filled with wonder."
    },
    {
      id: 3,
      name: "Arthur Albus",
      text: "Cape Town's beauty truly shines through with Explore Era. Hiking up Table Mountain and savoring local wines in the Cape Winelands were highlights. The team at Explore Era ensured unforgettable trip."
    },
  ]

  return (
    <div className='test-cont'>

      <div className="section"> <Slide bottom>
      <h1>WHAT TRAVELLERS ARE SAYING ABOUT US?</h1>
      <h2>TESTIMONIALS</h2>
      </Slide>
      </div>

          <div className="test-main">
          <Slide left>
      {tests.map(test => {
        return (
            <div className="cards" key={test.id}>
            <h2>{test.name}</h2>
            <p>{test.text}</p>
            </div>
        )
      })} </Slide>
          </div>

    </div>
  )
}

export default Reviews;